/**
 * @param {string} path
 * @param {object} queryObj
 * @param {string} baseUrl
 */
export default (path, queryObj = {}, baseUrl = window.location) => {
  const url = new URL(path, baseUrl);

  Object.keys(queryObj).forEach((key) => url.searchParams.set(key, queryObj[key]));

  return url.toString();
};
